__turbopack_context__.v({
  "container": "gRPQ_G_container",
});
